import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link
} from "react-router-dom";
import Que from "./screens/admin/Que";
import Calendar from "./screens/admin/Calendar";
import LoginDialog from "./components/Login";
import Join from "./screens/customer/join";
import Qr from "./screens/customer/qr";
import Stats from "./screens/admin/Stats";
import TicketPage from "./screens/TicketPage";
import Terminal from "./screens/Terminal";
import CartProvider from "./CartContext";
import Success from "./screens/customer/success";
import CustomerInfo from "./screens/admin/CustomerInfo";
import EditUserData from "./screens/EditUserData";
import EditPurchase from "./screens/EditPurchase";
import Coupon from "./screens/admin/Coupon";
import Vouchers from "./screens/admin/Vouchers";
import Settings from "./screens/admin/Settings";
import AdminTicket from "./screens/admin/Tickets";
import GiftCards from './screens/GiftCards';
import TicketValidator from "./screens/TicketValidator";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import { AlertsProvider } from "./AlertsContext";
import Alerts from "./components/Alerts";
import SuccessVoucher from "./screens/customer/successVoucher";
import { UserAuthProvider, useAuthUser } from "./UserAuthContext";
import BodyHeightListener from "./BodyHeightListener";
import Schedule from "./screens/admin/Schedule";

export default function App() {
  const [user, authLoading, error] = useAuthState(auth);

  return (
    <>
      <BodyHeightListener />
      <UserAuthProvider>
        <CartProvider>
        <AlertsProvider>
          <Router>
            {/* A <Switch> looks through its children <Route>s and
                      renders the first one that matches the current URL. */}
            <Routes>
              {/* Public */}
              <Route path="/" element={<LoginDialog buttonHidden={true} isOpen={true} redirect={'/que'} />} />
              <Route path="/tickets" element={<TicketPage />} />
              <Route path="/success/:id" element={<Success />} />
              <Route path="/successVoucher" element={<SuccessVoucher />} />
              <Route path="/qr/:location?" element={<Qr />} />
              <Route path="/join/:location?" element={<Join />} />
              <Route path="/edit-user-data/:id" element={<EditUserData />} />
              <Route path="/edit-purchase/:id" element={<EditPurchase />} />
              <Route path="/gift-cards" element={<GiftCards />} />
              {/* Private */}
              {user ?
                <>
                  <Route path="/terminals" element={<Terminal />} />
                  <Route path="/que" element={<Que />} />
                  <Route path="/stats" element={<Stats />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/customer-info" element={<CustomerInfo />} />
                  <Route path="/coupon" element={<Coupon />} />
                  <Route path="/vouchers" element={<Vouchers />} />
                  <Route path="/schedule" element={<Schedule />} />
                  <Route path="/ticket-validator/:purchaseId/:ticketId" element={<TicketValidator />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/ticket-admin" element={<AdminTicket />} />
                </> : ''}
            </Routes>
          </Router>
          <Alerts />
        </AlertsProvider>
      </CartProvider>
    </UserAuthProvider>
    </>
  );
}
